export default __webpack_public_path__ + "media/flags/gh-7d9a6bec.svg";